module.exports = __webpack_public_path__ + "img/wave2.035bcc54.svg";